import React, { Fragment, useEffect, useState } from 'react';
import { Button, Icon, Input, message, Modal, Popover, Row } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { PRODUCT_ENDPOINT, WARRANTY_ENDPOINT } from '../../services/endpoint';
import './style.scss';
import { useHistory } from 'react-router-dom';
import WarrantyFormModal from './component/WarrantyFormModal';

const { confirm } = Modal;

const DEFAULT_PAGE = {
	currentPage: 1, perpage: 20
};

export default () => {

	const [ds, setDs] = useState([]);
	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE, total: 0
	});
	const [visible, setVisible] = useState(false);
	const [currentRecord, setCurrentRecord] = useState(null);

	const handleOk = (values) => {
		console.log('Submitted:', values);
		const param = {
			id: currentRecord.id,
			durationUnit: values.durationUnit,
			warrantyTime: values.warrantyTime
		};
		window.setLoading(true);
		CommonService.post(WARRANTY_ENDPOINT, param).then(() => {
			setCurrentRecord(null);
			message.success('Cập nhật phiếu bảo hành thành công');
			onSearch();
		}).catch(err => {
			message.error(err?.data?.message);
		}).finally(() => {
			setVisible(false);
			window.setLoading(false);
		});
	};

	const handleCancel = () => {
		setVisible(false);
	};
	const handleOpenUpdate = (rc) => {
		setVisible(true);
		setCurrentRecord(rc);
	};

	const history = useHistory();

	const init = async () => {
		try {
			window.setLoading(true);
			const warrantyRes = await CommonService.get(WARRANTY_ENDPOINT, {
				page: page.currentPage - 1, size: page.perpage
			});
			setDs(warrantyRes.data?.contents);
			setPage({ ...page, total: warrantyRes.data?.totalElements });
		} catch (error) {
			message.error('Có lỗi xảy ra');
		} finally {
			window.setLoading(false);
		}
	};

	useEffect(() => {
		init();
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(WARRANTY_ENDPOINT, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements, ...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Mã phiếu',
			dataIndex: 'code',
			align: 'center',
			className: 'header-center-align',
			width: 150,
			render: (text, record) => {
				return <Button style={{ padding: '0', textWrap: 'wrap' }} type={'link'}
											 onClick={() => gotoDetail(record.id)}>{text}</Button>;
			}
		},

		{
			title: 'Sản phẩm',
			dataIndex: 'productName',
			align: 'center',
			className: 'header-center-align',
			width: 300,
			render: (text) => <b>{text}</b>
		}, {
			title: 'Mã sản phẩm',
			dataIndex: 'productCode',
			align: 'center',
			className: 'header-center-align',
			width: 150,
			render: (text) => <b>{text}</b>
		}, {
			title: 'Serial/IMEI',
			dataIndex: 'imei',
			align: 'center',
			className: 'header-center-align',
			width: 150,
			render: (text) => <span>{text}</span>

		}, {
			title: 'Mã đơn hàng',
			dataIndex: 'orderCode',
			width: 150,
			align: 'center',
			render: (text, record) => {
				return <Button style={{ padding: '0', textWrap: 'wrap' }} type={'link'}
											 onClick={() => gotoOrderDetail(record.orderId)}>{text}</Button>;
			}
		}, {
			title: 'Thời hạn bảo hành',
			dataIndex: 'warranty',
			align: 'center',
			width: 100,
			render: (text) => <span>{text}</span>
		}, {
			title: 'Ngày hết hạn',
			dataIndex: 'expiredDate',
			width: 150,
			align: 'center',
			render: (text) => <span>{dateToString(text, 'DD-MM-YYYY')}</span>
		},
		{
			title: 'Hành động',
			width: 100,
			align: 'center',
			render: (el, rc) => {
				return <Popover content={actionGroup(el, rc)}>
					<Button><Icon type="dash" /></Button>
				</Popover>;
			}
		}];

	const actionGroup = (el, rc) => {
		return (
			<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
				<Button type={'primary'} className={'mr-10'} onClick={() => gotoDetail(el.id)}> Yêu cầu BH </Button>
				<Button className={'mr-10'} onClick={() => handleOpenUpdate(rc)}> Cập nhật </Button>
				<Button type={'danger'} onClick={() => {
					confirm({
						title: 'Bạn có chắc chắn muốn hủy phiếu bảo hành này không?', onOk() {
							handleDelete(el.id);
						}, cancelText: 'Hủy'
					});
				}}> Hủy phiếu </Button>
			</div>
		);
	};

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	const handleDelete = (id) => {
		window.setLoading(true);
		CommonService.deleteRecord(WARRANTY_ENDPOINT, id).then(() => {
			onSearch(page);
			message.success('Xóa sản phẩm thành công');
		}).catch(err => {
			message.error(err?.data?.message);
		}).finally(() => {
			window.setLoading(false);
		});
	};

	const gotoDetail = (id) => {
		history.push('/warranty-claim-card/create/' + id);
	};

	const gotoOrderDetail = (id) => {
		history.push('/orders/' + id);
	};


	return (<Fragment>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã phiếu bảo hành, mã đơn hàng"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'param')}
					/>
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<TableCommon bordered={true}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
			/>
			<WarrantyFormModal visible={visible}
												 onOk={handleOk}
												 onCanced={handleCancel}
												 endDate={currentRecord?.expiredDate}
			/>
		</Fragment>

	);
};
